const routes = require('../routes.js') 
import Vue from "vue";
import i18n from "@/i18n";

const Custom = { // todo: make a clear name and use case
    install(Vue) {
        Vue.getRouteConfig = function(name) {
            return routes.dataRoutes.find(route => route.name === name);
        }
    },
    getRouteConfigs: function() {
        return routes.configsByLocale(i18n.locale);
    },
    getMetaByRoute: function(to) {
        const page = i18n.t(to.name, to.params.locale) || {}
        return {
            publicRoute: true,
            title: (page.meta && page.meta.title ? page.meta.title + " | " : "")  + i18n.t('menu.' + to.name) + " | Wiebke Winzer",
            description: (page.meta && page.meta.description ? page.meta.description : ''),
        };
    },
    setMetaAndTitle(to) {
        const meta = this.getMetaByRoute(to);
        document.documentElement.setAttribute('lang', to.params.locale)
        document.title = meta.title;
        const metaElement = document.getElementsByTagName('meta');
        metaElement["description"].content = meta.description;
    }
}
Vue.use(Custom)

export default Custom;
